import { Box, FormControlLabel, Stack, Switch, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import { colors } from 'src/global/styles/colors';
import { ProjectInputs } from 'src/global/types/project.type';
import { useDeployment } from 'src/provider/DeploymentProvider';
import { isAllowedPercentage } from 'src/utils/numberFormat';

import { AdminCheckbox } from '../AdminCheckbox';
import { AdminNumberFormat } from '../AdminNumberFormat';
import { KolTable } from './KolTable';

interface ReferralDiscountProps {
  isDisabled?: boolean;
}

export function ReferralDiscount({ isDisabled }: ReferralDiscountProps) {
  const { hasDeployed } = useDeployment();
  const {
    control,
    formState: { errors },
    setValue,
    clearErrors,
    watch,
  } = useFormContext<ProjectInputs>();
  const watchReferral = watch('referral');

  return (
    <Stack gap={3} width={'100%'}>
      <Stack direction={'row'} justifyContent={'space-between'}>
        <Typography fontSize={'16px'} fontWeight={500} color='white' lineHeight={'20px'} variant='h6'>
          Referral Discount
        </Typography>
        <Controller
          name='referral.isEnableDiscount'
          control={control}
          render={({ field: { onChange, value } }) => (
            <Switch disabled={isDisabled || hasDeployed} checked={value} onChange={onChange} />
          )}
        />
      </Stack>
      {watchReferral.isEnableDiscount ? (
        <>
          {' '}
          <Controller
            control={control}
            name={`referral.isEnableDiscountAll`}
            defaultValue={false}
            render={({ field: { onChange, value } }) => (
              <FormControlLabel
                label={<Typography color='white'>Everyone</Typography>}
                control={<AdminCheckbox checked={value} onChange={onChange} />}
              />
            )}
          />
          {watchReferral.isEnableDiscountAll ? (
            <Box width={'100%'}>
              <Typography paddingBottom={1} color={colors.neutral200} fontSize={'14px'} variant='h6'>
                Percentage
              </Typography>
              <Controller
                name='referral.discount'
                control={control}
                render={({ field }) => (
                  <AdminNumberFormat
                    isAllowed={isAllowedPercentage}
                    onValueChange={values => {
                      field.onChange(Number(values.floatValue));
                    }}
                    isError={!!errors?.referral?.discount}
                    errorMsg={errors?.referral?.discount?.message}
                    placeholder={'0%'}
                    readOnly={isDisabled}
                    {...field}
                  />
                )}
              />
            </Box>
          ) : null}
          <Controller
            control={control}
            name={`referral.isEnableDiscountKol`}
            defaultValue={false}
            render={({ field: { onChange, value } }) => (
              <FormControlLabel
                label={<Typography color='white'>KOL</Typography>}
                control={
                  <AdminCheckbox
                    checked={value}
                    disabled={isDisabled}
                    onChange={() => {
                      if (value) {
                        setValue('kols', []);
                        clearErrors('kols');
                      } else {
                        setValue('kols', [{ discount: 0, address: '' }]);
                      }
                      onChange(!value);
                    }}
                  />
                }
              />
            )}
          />
          {watchReferral.isEnableDiscountKol ? <KolTable isDisabled={isDisabled} /> : null}
        </>
      ) : null}
    </Stack>
  );
}
